"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accessArea = exports.footprint = exports.toLonLat = exports.subSatelliteTrack = exports.nadir = void 0;
var satellite_js_1 = require("satellite.js");
var vector_1 = require("./vector");
var errors_1 = require("./errors");
var transform_1 = require("./transform");
var utils_1 = require("./utils");
var _getNadir = function (positionAndVelocity, gmst) {
    if (typeof positionAndVelocity.position === "boolean") {
        throw TypeError("positionAndVelocity has not a number.");
    }
    var position = (0, satellite_js_1.eciToGeodetic)(positionAndVelocity.position, gmst);
    return [
        (0, satellite_js_1.degreesLong)(position.longitude),
        (0, satellite_js_1.degreesLat)(position.latitude),
    ];
};
var nadir = function (tleLine1, tleLine2, date) {
    var satrec = (0, satellite_js_1.twoline2satrec)(tleLine1, tleLine2);
    var positionAndVelocity = (0, satellite_js_1.propagate)(satrec, date);
    var gmst = (0, satellite_js_1.gstime)(date);
    return _getNadir(positionAndVelocity, gmst);
};
exports.nadir = nadir;
var subSatelliteTrack = function (tleLine1, tleLine2, start, end, userOptions) {
    var options = Object.assign({
        split: 360,
    }, userOptions);
    var satrec = (0, satellite_js_1.twoline2satrec)(tleLine1, tleLine2);
    var meanMotion = satrec.no; // [rad/min]
    var orbitPeriod = (2 * Math.PI) / (meanMotion / 60); // [sec]
    var dt = orbitPeriod / options.split;
    var tracks = [[]];
    var linestringIndex = 0;
    var d = new Date(start.getTime());
    while (d < end) {
        var positionAndVelocity = (0, satellite_js_1.propagate)(satrec, d);
        if (typeof positionAndVelocity.position === "boolean") {
            throw TypeError("positionAndVelocity has not a number.");
        }
        var gmst = (0, satellite_js_1.gstime)(d);
        var current = _getNadir(positionAndVelocity, gmst);
        if (tracks[linestringIndex].length > 0) {
            var before = tracks[linestringIndex][tracks[linestringIndex].length - 1];
            if (Math.abs(current[0] - before[0]) > 180) {
                if (current[0] < 0 && before[0] > 0) {
                    var lat = ((current[1] - before[1]) / (360 + current[0] - before[0])) *
                        (180 - before[0]) +
                        before[1];
                    tracks[linestringIndex].push([180, lat]);
                    tracks[++linestringIndex] = [[-180, lat]];
                }
                if (current[0] > 0 && before[0] < 0) {
                    var lat = ((current[1] - before[1]) / (-360 + current[0] - before[0])) *
                        (-180 - before[0]) +
                        before[1];
                    tracks[linestringIndex].push([-180, lat]);
                    tracks[++linestringIndex] = [[180, lat]];
                }
            }
        }
        tracks[linestringIndex].push(current);
        d.setSeconds(d.getSeconds() + dt);
    }
    return tracks;
};
exports.subSatelliteTrack = subSatelliteTrack;
var getGroundObservingPosition = function (satellitePosition, observeDirection, a, b, ex, ey, ez) {
    var c = a;
    var d = {
        x: (0, vector_1.dot)({ x: ex.x, y: ey.x, z: ez.x }, observeDirection),
        y: (0, vector_1.dot)({ x: ex.y, y: ey.y, z: ez.y }, observeDirection),
        z: (0, vector_1.dot)({ x: ex.z, y: ey.z, z: ez.z }, observeDirection),
    };
    var A = Math.pow(d.x, 2) / Math.pow(a, 2) + Math.pow(d.y, 2) / Math.pow(b, 2) + Math.pow(d.z, 2) / Math.pow(c, 2);
    var B = (2 * d.x * satellitePosition.x) / Math.pow(a, 2) +
        (2 * d.y * satellitePosition.y) / Math.pow(b, 2) +
        (2 * d.z * satellitePosition.z) / Math.pow(c, 2);
    var C = Math.pow(satellitePosition.x, 2) / Math.pow(a, 2) + Math.pow(satellitePosition.y, 2) / Math.pow(b, 2) + Math.pow(satellitePosition.z, 2) / Math.pow(c, 2) - 1;
    var D = Math.pow(B, 2) - 4 * A * C;
    var t1 = (-B + Math.sqrt(D)) / (2 * A);
    var t2 = (-B - Math.sqrt(D)) / (2 * A);
    if (isNaN(t1) || isNaN(t2))
        throw new errors_1.LookingAwayError();
    var P1 = (0, vector_1.add)(satellitePosition, (0, vector_1.multiple)(d, t1));
    var P2 = (0, vector_1.add)(satellitePosition, (0, vector_1.multiple)(d, t2));
    return t1 > t2 ? P2 : P1;
};
var _warp = function (lonlat, reference) {
    var lon = lonlat[0];
    if (reference && Math.abs(reference[0] - lon) >= 180) {
        if (reference[0] >= 0)
            lon += 360;
        else
            lon -= 360;
    }
    return [lon, lonlat[1]];
};
var toLonLat = function (point, reference) {
    return _warp([(0, satellite_js_1.degreesLong)(point.longitude), (0, satellite_js_1.degreesLat)(point.latitude)], reference);
};
exports.toLonLat = toLonLat;
var _getFootprint = function (positionAndVelocity, gmst, userOptions) {
    var options = Object.assign({
        insert: 5,
        fov: [15, 15],
        a: 6378.137,
        f: 1 / 298.257223563 // WGS84
    }, userOptions);
    if (typeof positionAndVelocity.position === "boolean" || typeof positionAndVelocity.velocity === "boolean") {
        throw TypeError("positionAndVelocity has not a number.");
    }
    var center = _getNadir(positionAndVelocity, gmst);
    var _a = [(options.fov[0] * Math.PI) / 180, (options.fov[1] * Math.PI) / 180], f1 = _a[0], f2 = _a[1];
    var f3 = Math.atan(Math.sqrt(Math.pow(Math.tan(f1), 2) + Math.pow(Math.tan(f2), 2)));
    var f4 = Math.atan(Math.tan(f1) / Math.tan(f2));
    var rf = {
        x: Math.sin(f3) * Math.cos(f4),
        y: Math.sin(f3) * Math.sin(f4),
        z: Math.cos(f3),
    };
    var lf = {
        x: Math.sin(f3) * Math.cos(f4),
        y: -Math.sin(f3) * Math.sin(f4),
        z: Math.cos(f3),
    };
    var lb = {
        x: -Math.sin(f3) * Math.cos(f4),
        y: -Math.sin(f3) * Math.sin(f4),
        z: Math.cos(f3),
    };
    var rb = {
        x: -Math.sin(f3) * Math.cos(f4),
        y: Math.sin(f3) * Math.sin(f4),
        z: Math.cos(f3),
    };
    var length = options.insert + 1;
    var ez = (0, vector_1.multiple)((0, vector_1.unit)(positionAndVelocity.position), -1);
    var ey = (0, vector_1.unit)((0, vector_1.cross)(positionAndVelocity.position, positionAndVelocity.velocity));
    var ex = (0, vector_1.unit)((0, vector_1.cross)(ey, ez));
    var a = options.a;
    var b = a * (1 - options.f);
    var positions = [
        getGroundObservingPosition(positionAndVelocity.position, rf, a, b, ex, ey, ez),
        getGroundObservingPosition(positionAndVelocity.position, lf, a, b, ex, ey, ez),
        getGroundObservingPosition(positionAndVelocity.position, lb, a, b, ex, ey, ez),
        getGroundObservingPosition(positionAndVelocity.position, rb, a, b, ex, ey, ez),
    ];
    if ((0, utils_1.within)([0, 0], __spreadArray(__spreadArray([], positions.map(function (position) { return [
        position.x, position.y
    ]; }), true), [[positions[0].x, positions[0].y]], false), { includeBorder: true })) {
        return (0, transform_1._transformEnclosingPoleRing)(__spreadArray(__spreadArray([], positions, true), [positions[0]], false).map(function (p) { return (0, exports.toLonLat)((0, satellite_js_1.eciToGeodetic)(p, gmst), center); }), "EPSG:4326", options.insert, positionAndVelocity.position.z >= 0);
    }
    // right front to left front
    {
        var direction = __assign({}, rf);
        for (var i = 1; i < length; i++) {
            direction.y += -(2 * Math.sin(f3) * Math.sin(f4)) / length;
            positions.splice(i, 0, getGroundObservingPosition(positionAndVelocity.position, direction, a, b, ex, ey, ez));
        }
    }
    // left front to left back
    {
        var direction = __assign({}, lf);
        for (var i = 1; i < length; i++) {
            direction.x += -(2 * Math.sin(f3) * Math.cos(f4)) / length;
            positions.splice(i + length, 0, getGroundObservingPosition(positionAndVelocity.position, direction, a, b, ex, ey, ez));
        }
    }
    // left back to right back
    {
        var direction = __assign({}, lb);
        for (var i = 1; i < length; i++) {
            direction.y += (2 * Math.sin(f3) * Math.sin(f4)) / length;
            positions.splice(i + length * 2, 0, getGroundObservingPosition(positionAndVelocity.position, direction, a, b, ex, ey, ez));
        }
    }
    // right back to right front
    {
        var direction = __assign({}, rb);
        for (var i = 1; i < length; i++) {
            direction.x += (2 * Math.sin(f3) * Math.cos(f4)) / length;
            positions.splice(i + length * 3, 0, getGroundObservingPosition(positionAndVelocity.position, direction, a, b, ex, ey, ez));
        }
    }
    var lonlats = positions.map(function (position) {
        return (0, exports.toLonLat)((0, satellite_js_1.eciToGeodetic)(position, gmst), center);
    });
    return __spreadArray(__spreadArray([], lonlats, true), [lonlats[0]], false);
};
var footprint = function (tleLine1, tleLine2, date, userOptions) {
    var satrec = (0, satellite_js_1.twoline2satrec)(tleLine1, tleLine2);
    var positionAndVelocity = (0, satellite_js_1.propagate)(satrec, date);
    var gmst = (0, satellite_js_1.gstime)(date);
    return _getFootprint(positionAndVelocity, gmst, userOptions);
};
exports.footprint = footprint;
var _getEdge = function (satellitePosition, gmst, a, b, ex, ey, ez, f3, insert, reference, start) {
    var edgePositions = [];
    var direction = start ? 1 : -1;
    var length = insert + 1;
    for (var i = 1; i < length; i++) {
        var theta = direction * (f3 - (i * 2 * f3) / length);
        edgePositions.push((0, exports.toLonLat)((0, satellite_js_1.eciToGeodetic)(getGroundObservingPosition(satellitePosition, {
            x: 0,
            y: Math.sin(theta),
            z: Math.cos(theta),
        }, a, b, ex, ey, ez), gmst), reference));
    }
    return edgePositions;
};
var accessArea = function (tleLine1, tleLine2, start, end, userOptions) {
    var options = Object.assign({
        split: 360,
        roll: 10,
        radius: 6378.137,
        f: 1 / 298.257223563,
        insert: 5,
    }, userOptions);
    var satrec = (0, satellite_js_1.twoline2satrec)(tleLine1, tleLine2);
    var meanMotion = satrec.no; // [rad/min]
    var orbitPeriod = (2 * Math.PI) / (meanMotion / 60); // [sec]
    var dt = orbitPeriod / options.split;
    var f3 = (options.roll * Math.PI) / 180;
    var leftVectors = [];
    var rightVectors = [];
    var startEdgePositions = [];
    var leftPositions = [];
    var rightPositions = [];
    var onboardIndex = 0;
    var across = 0;
    var reference = null;
    var leftTrack = [];
    var rightTrack = [];
    var linearRings = [];
    var d = new Date(start.getTime());
    while (d < end) {
        var positionAndVelocity = (0, satellite_js_1.propagate)(satrec, d);
        if (typeof positionAndVelocity.position === "boolean" ||
            typeof positionAndVelocity.velocity === "boolean") {
            throw TypeError("positionAndVelocity has not a number.");
        }
        var gmst = (0, satellite_js_1.gstime)(d);
        var ez = (0, vector_1.multiple)((0, vector_1.unit)(positionAndVelocity.position), -1);
        var ey = (0, vector_1.unit)((0, vector_1.cross)(positionAndVelocity.position, positionAndVelocity.velocity));
        var ex = (0, vector_1.unit)((0, vector_1.cross)(ey, ez));
        var a = options.radius;
        var b = a * (1 - options.f);
        var leftVector = getGroundObservingPosition(positionAndVelocity.position, {
            x: 0,
            y: Math.sin(-f3),
            z: Math.cos(f3),
        }, a, b, ex, ey, ez);
        var leftLocation = (0, satellite_js_1.eciToGeodetic)(leftVector, gmst);
        var rightVector = getGroundObservingPosition(positionAndVelocity.position, {
            x: 0,
            y: Math.sin(f3),
            z: Math.cos(f3),
        }, a, b, ex, ey, ez);
        var rightLocation = (0, satellite_js_1.eciToGeodetic)(rightVector, gmst);
        if (!reference) {
            reference = _getNadir(positionAndVelocity, gmst);
            startEdgePositions = _getEdge(positionAndVelocity.position, gmst, a, b, ex, ey, ez, f3, options.insert, reference, true);
        }
        var left = (0, exports.toLonLat)(leftLocation, reference);
        var right = (0, exports.toLonLat)(rightLocation, reference);
        if (across === 0) {
            if ((180 - Math.abs(left[0])) * (180 - Math.abs(right[0])) < 0)
                across = 1;
        }
        else if (across === 1) {
            if ((180 - Math.abs(left[0])) * (180 - Math.abs(right[0])) > 0)
                across = -1;
        }
        leftVectors.push(leftVector);
        rightVectors.push(rightVector);
        leftPositions.push(left);
        rightPositions.push(right);
        onboardIndex++;
        if (onboardIndex > 1) {
            var vectorRing = __spreadArray(__spreadArray(__spreadArray([], leftVectors, true), __spreadArray([], rightVectors, true).reverse(), true), [
                leftVectors[0],
            ], false);
            if ((0, utils_1.within)([0, 0], vectorRing.map(function (v) { return [v.x, v.y]; }))) {
                leftTrack = leftTrack.concat(leftPositions.slice(0, leftPositions.length - 1));
                rightTrack = rightTrack.concat(rightPositions.slice(0, rightPositions.length - 1));
                var middleLeftPosition = __spreadArray([], leftPositions[leftPositions.length - 1], true);
                var middleRightPosition = __spreadArray([], rightPositions[rightPositions.length - 1], true);
                if (Math.abs(middleLeftPosition[0] - leftTrack[leftTrack.length - 1][0]) >
                    180) {
                    middleLeftPosition[0] +=
                        leftTrack[leftTrack.length - 1][0] > 0 ? 360 : -360;
                }
                if (Math.abs(middleRightPosition[0] - rightTrack[rightTrack.length - 1][0]) > 180) {
                    middleRightPosition[0] +=
                        rightTrack[rightTrack.length - 1][0] > 0 ? 360 : -360;
                }
                leftTrack.push(middleLeftPosition);
                rightTrack.push(middleRightPosition);
                var polarLat = positionAndVelocity.position.z >= 0 ? 90 : -90;
                leftTrack.push([middleLeftPosition[0], polarLat]);
                rightTrack.push([middleRightPosition[0], polarLat]);
                linearRings.push(__spreadArray(__spreadArray(__spreadArray([
                    rightTrack[0]
                ], startEdgePositions, true), leftTrack, true), __spreadArray([], rightTrack, true).reverse(), true));
                leftVectors = [leftVector];
                rightVectors = [rightVector];
                reference = _getNadir(positionAndVelocity, gmst);
                var left_1 = (0, exports.toLonLat)(leftLocation, reference);
                leftPositions = [left_1];
                var right_1 = (0, exports.toLonLat)(rightLocation, reference);
                rightPositions = [right_1];
                onboardIndex = 1;
                across =
                    (180 - Math.abs(left_1[0])) * (180 - Math.abs(right_1[0])) < 0 ? 1 : 0;
                leftTrack = [[left_1[0], polarLat]];
                rightTrack = [[right_1[0], polarLat]];
                startEdgePositions = [];
            }
            else if (across < 1) {
                var current = _getNadir(positionAndVelocity, gmst);
                if (across === 0) {
                    if (Math.abs(current[0] - reference[0]) >= 180) {
                        across = -1;
                    }
                    else {
                        leftTrack.push(leftPositions[0]);
                        rightTrack.push(rightPositions[0]);
                    }
                }
                if (across < 0) {
                    leftTrack = leftTrack.concat(leftPositions);
                    rightTrack = rightTrack.concat(rightPositions);
                    var linearRing = __spreadArray(__spreadArray([rightTrack[0]], startEdgePositions, true), leftTrack, true);
                    var endeEdgePositions = (startEdgePositions = _getEdge(positionAndVelocity.position, gmst, a, b, ex, ey, ez, f3, options.insert, reference, false));
                    linearRing = linearRing.concat(__spreadArray(__spreadArray([], endeEdgePositions, true), __spreadArray([], rightTrack, true).reverse(), true));
                    linearRings.push(linearRing);
                    rightTrack = [];
                    leftTrack = [];
                }
                leftVectors = [leftVector];
                rightVectors = [rightVector];
                reference = current;
                leftPositions = [(0, exports.toLonLat)(leftLocation, reference)];
                rightPositions = [(0, exports.toLonLat)(rightLocation, reference)];
                onboardIndex = 1;
                if (across < 0) {
                    startEdgePositions = startEdgePositions = _getEdge(positionAndVelocity.position, gmst, a, b, ex, ey, ez, f3, options.insert, reference, true);
                }
                across = 0;
            }
        }
        d.setSeconds(d.getSeconds() + dt);
        if (end <= d) {
            leftTrack = leftTrack.concat(leftPositions);
            rightTrack = rightTrack.concat(rightPositions);
            if (leftTrack.length > 1 && rightTrack.length > 1) {
                var linearRing = __spreadArray(__spreadArray([rightTrack[0]], startEdgePositions, true), leftTrack, true);
                var endEdgePositions = _getEdge(positionAndVelocity.position, gmst, a, b, ex, ey, ez, f3, options.insert, reference, false);
                linearRing = linearRing.concat(__spreadArray(__spreadArray([], endEdgePositions, true), __spreadArray([], rightTrack, true).reverse(), true));
                linearRings.push(linearRing);
            }
        }
    }
    return linearRings;
};
exports.accessArea = accessArea;
